import React from "react";
import styles from "./styles.module.scss";

export interface RowWithOptionalClick {
  onClick?: () => void;
}

interface BusinessTableProps<T extends RowWithOptionalClick> {
  columns: { type: string; value: string }[];
  rows: T[]; // ✅ rows is an array of the generic row type
  renderCell: (column: string, row: T, rowIndex: number) => React.ReactNode;
}

const BusinessTable = <T extends RowWithOptionalClick>({
  columns,
  rows,
  renderCell,
}: BusinessTableProps<T>): React.ReactElement => {
  return (
    <div className={styles["container"]}>
      <table dir="rtl">
        <thead>
          <tr className={styles[`columns-${columns.length}`]}>
            {columns.map((column) => (
              <th key={column.type} id={column?.type}>
                {column.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={styles[`columns-${columns.length}`]}
              style={{ cursor: row?.onClick ? "pointer" : "" }}
              onClick={row?.onClick}>
              {columns.map((column) => (
                <td key={column.type} id={column?.type}>
                  {renderCell(column.type, row, rowIndex)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(BusinessTable);
